import { ForgotPasswordController as controller } from './forgotPassword.controller';
import template from './forgotPassword.html';
import '../../common/ui/componentHeader/componentHeader';

export const forgotPasswordComponent = {
  name: 'forgotPasswordComponent',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    returnTo: '<',
  },
};
